"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EntityInfo_1 = require("./EntityInfo");
/**
 * Get the entity element from a child (or the element itself) of an entity.
 * If the given node is not part of an entity, it will return null
 * @param editor The editor to get entity from
 * @param node The child node
 */
function getEntityElement(editor, node) {
    return (node && editor.getElementAtCursor(EntityInfo_1.getEntitySelector(), node)) || null;
}
exports.default = getEntityElement;
//# sourceMappingURL=getEntityElement.js.map